let currentSlide = 0;
console.log("event-bar.js")
document.addEventListener("DOMContentLoaded", function() {
    const slides = document.querySelectorAll('.modal-content-offer');

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active-offer', i === index);
      });
    }

    window.EventBarNextSlide = function() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    window.EventBarPrefSlide = function() {
      currentSlide = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(currentSlide);
    }
  });